module.exports = __webpack_public_path__ + "static/rappers-delight-left-2b185d044d2aab38ecdc0bba1caa4cc8.png";